import { charcoal } from '../shared/colors';
import { respondTo } from '../shared/breakpoints';


const GeneralStyles = `
* {
  box-sizing: border-box;
}
html,
body {

  max-width: 100%;

  &.no-scroll {
    overflow: hidden;
 
 
  }
}
body {
  font-family: 'proxima-nova', sans-serif;
  font-size: 16px;
  color: ${charcoal};
  
}

.no-wrap{
  text-wrap: no-wrap;
}

a,
button {
  font-family: inherit;
}

sup {
  vertical-align: top;
  position: relative;
  top: -0.3em;
  font-size: max(50%, 10px);
}
sub {
  vertical-align: bottom;
  position: relative;
  bottom: -0.3em;
  font-size: max(42%, 10px);
}
.no-wrap {
  white-space: nowrap;
}
em {
  font-style: italic;
}
strong {
  font-weight: bold;
}
.mob-onlyspace{
  display:none
    @media (min-width: 768px) {
    display:block
  }
 }
   .redlink{
   color:rgb(214, 49, 38)}  

.r-size {
font-size: max(70%, 10px);
}
     
`;


export default GeneralStyles;